import { render } from "./RadioPillGroup.vue?vue&type=template&id=7898c03c"
import script from "./RadioPillGroup.vue?vue&type=script&lang=js"
export * from "./RadioPillGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__